// src/screens/merchant/MerchantDashboard.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MerchantDashboard.css';

import backIcon from '../../assets/backspace-icon.png';

function MerchantDashboard({ user }) {
  const navigate = useNavigate();

  const tiles = [
    { label: 'My Products', icon: '🛍️', route: '/merchant/products' },
    { label: 'Promotions', icon: '🚀', route: '/merchant/sponsorships' },
    { label: 'Flash Sales', icon: '⚡', route: '/merchant/flash-sale' }, // 🆕 new tile
    { label: 'Store Insights', icon: '📊', route: '/merchant/insights' },
    { label: 'Orders', icon: '📦', route: '/orders' },
    { label: 'Reviews', icon: '⭐', route: '/merchant/reviews' },
    { label: 'Metrics', icon: '🧮', route: '/merchant/metrics' },
  ];

  if (!user || !user.isMerchant) {
    return <div className="merchant-dashboard-denied">Access denied.</div>;
  }

  const handleBack = () => {
    navigate(`/store/${user.businessUsername}`);
  };

  return (
    <div className="merchant-dashboard-container">
      {/* 🔝 Fixed Top Bar */}
      <div className="merchant-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="merchant-back-icon"
          onClick={handleBack}
        />
        <h2>Merchant Dashboard</h2>
      </div>

      {/* 🔄 Scrollable Tile Grid */}
      <div className="merchant-dashboard-scroll">
        <div className="merchant-tiles-grid">
          {tiles.map((tile, index) => (
            <div
              key={index}
              className="merchant-tile"
              onClick={() => navigate(tile.route)}
            >
              <div className="merchant-icon">{tile.icon}</div>
              <div className="merchant-label">{tile.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MerchantDashboard;
